
export default {
  namespaced: true,
  state: {
    AC_COMPANY_ID: process.env.VUE_APP_AC_COMPANY_ID
  }
}